// extracted by mini-css-extract-plugin
export default {"primary":"#009dff","secondary":"#fff","success":"#00b913","error":"#bd0000","warning":"#b99000","info":"#17a2b8","link_color":"#2420d1"};